import { CommonModule } from '@angular/common';
import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-no-content',
  templateUrl: './no-content.component.html',
  styleUrls: ['./no-content.component.scss'],
  imports: [IonicModule, CommonModule, TranslatePipe]
})
export class NoContentComponent {
  public defaultIcon = 'search-outline';

  @Input()
  public icon: String | null = null;

  @Input()
  public inline = false;

  @ContentChild('header') headerTemplate?: TemplateRef<any>;
  @ContentChild('message') messageTemplate?: TemplateRef<any>;

  constructor() {}
}
